module.exports = "/_next/static/images/errorLight-5f75f863b60247ac7ca6166638b5e687.svg";